import './Text.scoped.scss'

export default function Text({response, setResponse, disabled = false, className = '', placeholder = 'Type an answer...'}) {
  const handleChange = (event) => {
    setResponse(event.target.value);
  }

  return (
    <div className={`answers grow ${className}`}>
      <textarea
        placeholder={placeholder}
        onChange={handleChange}
        disabled={disabled}
        value={response || ''}>
      </textarea>
    </div>
  )
}
